// extracted by mini-css-extract-plugin
export default {"brand":"Layout_brand__YiJrz","profile":"Layout_profile__Zjf0p","content":"Layout_content__cshz7"};